import React from 'react';
import { Helmet } from 'react-helmet-async';
import office_img from '../../nz_office6.jpg';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ConsultantBlock from '../../components/ConsultantBlock/ConsultantBlock';
import ServiceStripe from '../../components/ServiceStripe/ServiceStripe';

import './HomePage.scss';

function HomePage() {
  return (
    <div className="App">
      <Helmet>
        <title>Majority AI - Machine Learning & AI Solutions | Expert AI Consulting</title>
        <meta name="description" content="Majority AI offers comprehensive machine learning solutions from data processing to model deployment. Expert AI consulting for computer vision, LLM/RAG, and reinforcement learning." />
        <meta name="keywords" content="Majority AI, MajorityAI, machine learning, AI consulting, computer vision, LLM solutions, RAG solutions, reinforcement learning, AI development" />
        <link rel="canonical" href="https://www.majorityai.com/" />
      </Helmet>
      <Navbar />
        <header className="App-header">
            <div className="background-image-container" style={{backgroundColor: 'white'}}>
                <img src={office_img} alt="office"
                     fetchpriority="high" className="office"/>

                <div className="content-overlay">
                    <ConsultantBlock />
                </div>
            </div>

            <div className="section-spacing" style={{backgroundColor: 'white'}}><ServiceStripe /></div>

        </header>
        <Footer />
    </div>
  );
}

export default HomePage;